var React = require("react");
var ReactDOM = require("react-dom");

var Canvas = require("./Canvas");
var domReady = require("domready");

var Graph = require("./graph");

var Vector = require("./vector");
var eventPosition = require("./event-position");

const MIN_EASE_RUNS = 100;

const MAX_NODES = 50;
const WIDTH = 1000;
const HEIGHT = 800;

const SIZE = 40;

const SEPARATION_LIMIT = SIZE * 2.5;
const EDGE_LIMIT = SIZE * 1.4;

const TENSION_LIMIT = Math.pow(SIZE, 0.34);

const HALF_SIZE = SIZE / 2;
const HALF_WIDTH = WIDTH / 2;
const HALF_HEIGHT = HEIGHT / 2;

var minX, minY, maxX, maxY, maxDepth;

function updateLimits(graph)
{
    minX = Infinity;
    minY = Infinity;
    maxX = -Infinity;
    maxY = -Infinity;
    maxDepth = -Infinity;

    var nodes = graph.getNodes();
    for (var i = 0; i < nodes.length; i++)
    {
        var node = nodes[i];

        if (isNaN(node.x) || isNaN(node.y))
        {
            console.error("NAN", graph);
        }

        minX = Math.min(minX, node.x);
        minY = Math.min(minY, node.y);
        maxX = Math.max(maxX, node.x);
        maxY = Math.max(maxY, node.y);
        maxDepth = Math.max(maxDepth, node.depth || 1);
    }
}

var graph = new Graph({
    separationLimit: SEPARATION_LIMIT,
    edgeLimit: EDGE_LIMIT
});

graph.growRandom(MAX_NODES);
graph.arrange();

updateLimits(graph);

var frame = 0;
//for (var i=0; i < MIN_EASE_RUNS; i++)
//{
//    graph.ease();
//    frame++;
//}


var easing = true, stopEasing = false;


var redraw = false;
var offsetX;
var offsetY;

var tensionLimit = TENSION_LIMIT;

var locked = {

};

function mainLoop(ctx)
{
    var max;

    if (stopEasing)
    {
        console.log("Stop at #", frame, max);
        //console.log(JSON.stringify(graph.clean()));

        easing = false;
        stopEasing = false;
    }

    if (easing || redraw)
    {
        redraw = false;

        if (easing)
        {
            frame++;

            max = graph.ease();

            for (var id in locked)
            {
                if (locked.hasOwnProperty(id))
                {
                    var pos = locked[id];
                    if (pos)
                    {
                        var node = graph.nodes[id];
                        node.x = pos.x;
                        node.y = pos.y;
                    }
                }
            }


            if (draggedNode)
            {
                var pos = dragCurrent.copy().subtract(offsetX, offsetY);

                draggedNode.x = pos.x;
                draggedNode.y = pos.y;
                draggedNode.dx = 0;
                draggedNode.dy = 0;
            }

            updateLimits(graph);

            window.max = max;
            if (frame > MIN_EASE_RUNS && max < tensionLimit && !draggedNode)
            {
                stopEasing = true;
            }
        }

        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, 1000, 800);

        ctx.fillStyle = "#f00";
        ctx.strokeStyle = "#444";
        ctx.lineWidth = 3;

        offsetX = HALF_WIDTH - (minX + maxX) / 2;
        offsetY = HALF_HEIGHT - (minY + maxY) / 2;

        //console.log(offsetX, offsetY);

        var nodes = graph.getNodes();
        for (var i = 0; i < nodes.length; i++)
        {
            var n = nodes[i];

            var refs = n.ref;
            for (var j = 0; j < refs.length; j++)
            {
                var n2 = nodes[refs[j]];

                if (n.id < n2.id)
                {
                    ctx.beginPath();
                    ctx.moveTo((n.x | 0) + offsetX, (n.y | 0) + offsetY);
                    ctx.lineTo((n2.x | 0) + offsetX, (n2.y | 0) + offsetY);
                    ctx.stroke();
                }
            }
        }

        for (i = 0; i < nodes.length; i++)
        {
            n = nodes[i];

            var v = (n.depth * 255 / maxDepth) | 0;
            ctx.fillStyle = "rgb(" + (255 - v) + ",96, " + v + ")";

            var x = ((n.x - SIZE / 2) | 0) + offsetX;
            var y = ((n.y - SIZE / 2) | 0) + offsetY;

            ctx.fillRect(x, y, SIZE, SIZE);

            if (locked[n.id])
            {
                ctx.strokeRect(x, y, SIZE, SIZE);
            }

        }
    }
}

var draggedNode = null;
var dragLocked;
var dragOffset;
var dragCurrent;
var dragInitial;

function findNode(x, y)
{
    var nodes = graph.nodes;

    for (var i = 0; i < nodes.length; i++)
    {
        var node = nodes[i];

        if (x >= node.x - HALF_SIZE && x < node.x + HALF_SIZE &&
            y >= node.y - HALF_SIZE && y < node.y + HALF_SIZE)
        {
            return node;
        }
    }
    return null;
}

var Screen = React.createClass({

    componentDidMount: function ()
    {
        console.log("CANVAS REF", this.refs.canvas);

        window.addEventListener("mouseup", this.onMouseUp, true);

    },

    componentWillUnmount: function (ev)
    {
        window.removeEventListener("mouseup", this.onMouseUp, true);
    },

    onMouseUp: function (ev)
    {
        if (draggedNode)
        {
            if (dragLocked)
            {
                console.log(ev.ctrlKey);

                if (ev.ctrlKey)
                {
                    var pos = eventPosition(ev, ReactDOM.findDOMNode(this.refs.canvas)).subtract(offsetX, offsetY);

                    var node = findNode(pos.x, pos.y);
                    if (node)
                    {
                        console.log("toggle", node);

                        if (locked[node.id])
                        {
                            locked[node.id] = null;
                        }
                        else
                        {
                            locked[node.id] = new Vector(node.x, node.y);
                        }

                        redraw = true;
                    }
                }
            }
            else
            {
                var pos = eventPosition(ev, ReactDOM.findDOMNode(this.refs.canvas));

                if (pos.x < 0 || pos.y < 0 || pos.x >= WIDTH || pos.y >= HEIGHT)
                {
                    console.log("reset");
                    draggedNode.x = dragInitial.x - offsetX;
                    draggedNode.y = dragInitial.y - offsetY;
                }
                else
                {
                    draggedNode.x = pos.x - offsetX;
                    draggedNode.y = pos.y - offsetY;

                    stopEasing = true;
                }
            }
            draggedNode = null;
        }
    },


    onMouseDown: function (ev)
    {
        //console.log("MOUSE DOWN");

        var pos = eventPosition(ev, ReactDOM.findDOMNode(this.refs.canvas)).subtract(offsetX, offsetY);

        var node = findNode(pos.x, pos.y);
        if (node)
        {
            //console.log("DRAG ON", node);
            draggedNode = node;
            dragLocked = true;
            dragOffset = pos.subtract(node);
            dragInitial = new Vector(node.x + offsetX, node.y + offsetY);
        }
    },

    onMouseMove: function (ev)
    {
        if (draggedNode)
        {
            var pos = eventPosition(ev, ReactDOM.findDOMNode(this.refs.canvas)).subtract(offsetX, offsetY).add(dragOffset);

            var len = pos.copy().subtract(dragInitial.x - offsetX, dragInitial.y - offsetY).len();
            if (dragLocked && len > 2)
            {
                dragLocked = false;
                frame = 0;
            }

            if (!dragLocked)
            {
                //console.log("move to ", pos);

                draggedNode.x = pos.x;
                draggedNode.y = pos.y;

                dragCurrent = pos.add(offsetX, offsetY);
                easing = true;
            }
        }
    },

    render: function ()
    {
        return (
            <div className="screen">
                <div className="block" style={{
                    width: WIDTH,
                    height: HEIGHT
                }}>
                    <Canvas
                        ref="canvas"
                        main={ mainLoop }
                        width={ WIDTH } height={ HEIGHT }
                        onMouseMove={ this.onMouseMove }
                        onMouseDown={ this.onMouseDown }
                        onDblClick={ this.onDblClick }
                    />
                </div>
                <div className="block">
                    <h1>Random graph layouter</h1>
                    <table>
                        <tbody>
                            <tr>
                                <td><label htmlFor="maxNodes">Node Count</label></td>
                                <td><input id="maxNodes" ref="maxNodes" type="text" title="Number of nodes" defaultValue={ MAX_NODES } /></td>
                            </tr>
                            <tr>
                                <td><label htmlFor="edgeLimit">Edge Max</label></td>
                                <td><input id="edgeLimit" ref="edgeLimit" type="text" title="Distance at which an edge will start pulling" defaultValue={ EDGE_LIMIT } /></td>
                            </tr>
                            <tr>
                                <td><label htmlFor="separationLimit">Separation Threshold</label></td>
                                <td><input id="separationLimit" ref="separationLimit" title="Distance at which the separation force stops" type="text" defaultValue={ SEPARATION_LIMIT } /></td>
                            </tr>
                            <tr>
                                <td><label htmlFor="tensionThreshold">Tension Threshold</label></td>
                                <td><input id="tensionThreshold" ref="tensionThreshold" type="text" title="Tension value to stop at after" defaultValue={ TENSION_LIMIT } /></td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>
                                    <input type="submit" value="Regenerate" onClick={ () => {

                                        graph = new Graph({
                                            separationLimit: +this.refs.separationLimit.value,
                                            edgeLimit: +this.refs.edgeLimit.value
                                        });

                                        graph.growRandom(+this.refs.maxNodes.value);
                                        graph.arrange();
                                        updateLimits(graph);

                                        tensionLimit = +this.refs.tensionThreshold.value;
                                        frame = 0;
                                        //for (var i=0; i < MIN_EASE_RUNS; i++)
                                        //{
                                        //    graph.ease();
                                        //    frame++;
                                        //}
                                        easing = true;

                                    }} />
                                    <input type="submit" value="Ease" onClick={ () => {

                                        graph.options.separationLimit = +this.refs.separationLimit.value;
                                        graph.options.edgeLimit = +this.refs.edgeLimit.value;
                                        easing = true;

                                    }} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        );
    }
});


domReady(function ()
{
    ReactDOM.render( <Screen separationLimit={ SEPARATION_LIMIT } edgeLimit = { EDGE_LIMIT } />
        ,
        document.getElementById("root"),
        function ()
        {
            console.log("done");
        }
    )

});


